<template>
  <main class="noItem">
    <i class="material-icons-outlined">meeting_room</i>Pas de salles<small>Nous les ajouterons bientôt</small>
  </main>
</template>

<style scoped>
.noItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  min-height: 400px;
}

.noItem i.material-icons-outlined {
  font-size: 128px;
}
</style>

<script>
export default {
}
</script>